export default "{\n    \"label\": \"Fabricante\"\n}\n"